import React, { Suspense, useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { IoIosAdd } from "react-icons/io";
import ProductBulkUpload from "../ProductBulkUpload/ProductBulkUpload";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "react-js-pagination";
import classes from "./ProductListing.module.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useToasts } from "react-toast-notifications";
import { FiCopy, FiPlusCircle } from "react-icons/fi";
import placeholder from "../../assets/images/placeholder.png";
import ImageUploadModal from "../ImageUploadModal/ImageUploadModal";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Loader as LoaderIcon } from "react-feather";
import { ThreeDots } from "react-loader-spinner";
import { GiPush } from "react-icons/gi";
import toast from "react-hot-toast";
import PushToCmsModal from "../../components/ProductListing/PushToCmsModal";

const ProductListing = () => {
  const { addToast } = useToasts();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkModalOpen, setisBulkModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState({
    bodyType: "",
    company: "",
    gender: "",
    status: "",
  });
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const [isFinalConfirmationOpen, setIsFinalConfirmationOpen] = useState(false);
  const [tooltipData, setTooltipData] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const [isImageUploadModalOpen, setIsImageUploadModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filterOptions, setFilterOptions] = useState({
    genderOptions: [],
    bodyTypeOptions: [],
    companyOptions: [],
    statusOptions: [],
  });
  const [openSandboxMessage, setOpenSandboxMessage] = useState("");
  const [openSandboxPush, setOpenSandboxPush] = useState(false);
  const [sandBoxStatus, setSandBoxStatus] = useState(false);
  const [pushLoader, setPushLoader] = useState(false);
  const [rejectedProducts, setRejectedProducts] = useState(false);
  const [pushSummary, setPushSummary] = useState([]);
  const [summaryLoader, setSummaryLoader] = useState(false);
  const [openRows, setOpenRows] = useState([]);
  const dispatch = useDispatch();

  const handlePush = async (selectedProducts) => {
    try {
      setPushLoader(true);
      const response = await apiHandler({
        url: endpoint.PUSH_PRODUCTS,
        data: {
          aProductsJson: selectedProducts,
        },
        authToken: authData,
        method: "POST",
        storeId,
        dispatch,
      });

      if (response.data.status === "success") {
        setOpenSandboxMessage(true);

        // toast.success(response.data.message);
        setSandBoxStatus(response.data.message);
      } else {
        setSandBoxStatus(response.data.message);
        setOpenSandboxMessage(true);
        setRejectedProducts(response.data.data.validationErrors);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPushLoader(false);
    }
  };

  const toggleRow = (productId) => {
    setOpenRows((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleBulkModalToggle = () => {
    setisBulkModalOpen(!isBulkModalOpen);
  };

  const handleDeleteClick = () => {
    setIsDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirm = () => {
    setIsDeleteConfirmationOpen(false);
    setIsFinalConfirmationOpen(true);
  };

  const handleFinalDeleteConfirm = async () => {
    setIsFinalConfirmationOpen(false);
    const data = {
      bConfirmation: true,
    };
    const response = await apiHandler({
      url: endpoint.DELETE_PRODUCTS,
      method: "DELETE",
      authToken: authData,
      data: data,
      storeId,
      dispatch,
    });
    if (response.data.status === "success") {
      addToast("Products Deleted Successfully", {
        appearance: "success",
      });
      setCurrentPage(1);
      fetchProducts();
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
    setCurrentPage(1);
  };

  const fetchProducts = async () => {
    try {
      setLoader(true);
      let url = `${
        endpoint.GET_PRODUCTS
      }?iPageNumber=${currentPage}&iPageSize=${12}`;

      if (filters.gender) {
        url += `&iGenderId=${filters.gender}`;
      }

      if (filters.company) {
        url += `&iStoreId=${filters.company}`;
      }

      if (filters.bodyType) {
        url += `&iBodyTypeId=${filters.bodyType}`;
      }
      if (filters.status) {
        url += `&iStatusId=${filters.status}`;
      }

      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        setProducts(response.data.data.productData);
        setTotalCount(response.data.data.totalRecords);
        if (
          filterOptions.genderOptions.length === 0 &&
          filterOptions.bodyTypeOptions.length === 0
        ) {
          const filtersData = response.data.data.filters;
          setFilterOptions({
            genderOptions: filtersData.genderFilter,
            bodyTypeOptions: filtersData.bodyTypeFilter,
            companyOptions: filtersData.storeFilter,
            statusOptions: filtersData.statusFilter,
          });
        }
      }
    } catch (error) {
      console.log("Error fetching products", error);
    } finally {
      setLoader(false);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    fetchProducts();
  }, [filters, currentPage]);

  const handleMouseEnter = (product) => {
    setTooltipData(product);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleImageUploadModalToggle = () => {
    setIsImageUploadModalOpen(!isImageUploadModalOpen);
  };

  const handleImageUploadSuccess = () => {
    setCurrentPage(1);
    fetchProducts();
  };

  const getPushSummary = async () => {
    try {
      setSummaryLoader(true);
      const response = await apiHandler({
        url: endpoint.GET_PUSH_SUMMARY,
        authToken: authData,
        method: "GET",
        storeId,
        dispatch,
      });

      if (response.data.status === "success") {
        setPushSummary(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching summary", error);
    } finally {
      setSummaryLoader(false);
    }
  };

  const styles = {
    container: {
      maxWidth: "600px",
      margin: "10px auto",
      padding: "10px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      fontFamily: "Arial, sans-serif",
    },
    title: {
      textAlign: "center",
      marginBottom: "20px",
      fontWeight: "bold",
      color: "#333",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "15px",
    },
    header: {
      padding: "10px",
      textAlign: "left",
      backgroundColor: "#f4f4f4",
      color: "#333",
      fontWeight: "bold",
    },
    row: {
      padding: "10px",
      textAlign: "left",
      borderBottom: "1px solid #ddd",
    },
    footer: {
      textAlign: "center",
      fontSize: "14px",
      color: "#555",
    },
  };

  return (
    <>
      <div className="flex ">
        <div className={`mx-auto p-0 ${classes.fullwidth}`}>
          <div className={classes.topheader}>
            <div className="d-lg-flex d-sm-flex justify-between">
              <span className={`p-lg-1 ${classes.titlename}`}>
                Product Sandbox
              </span>
              <div className="flex gap-5">
                <button
                  onClick={() => {
                    getPushSummary();
                    setOpenSandboxPush(true);
                  }}
                  className={`p-2 px-3 ${classes.back}`}
                  style={{ backgroundColor: "#646af5" }}
                >
                  <GiPush size={20} className="mr-2" />
                  Push products
                </button>
                {/* <button
                  onClick={() => {
                    handleModalToggle();
                  }}
                  className={`p-2 px-3 ${classes.back}`}
                  style={{ backgroundColor: "#646af5" }}
                >
                  <IoIosAdd size={20} /> Upload Products
                </button> */}
                <button
                  className={`p-2 px-3 ${classes.back}`}
                  onClick={() => {
                    handleBulkModalToggle();
                  }}
                  style={{ backgroundColor: "#646af5" }}
                >
                  <IoIosAdd size={20} /> Upload Images
                </button>
              </div>
            </div>
          </div>

          <div className={classes.middle_main_container}>
            <div className="p-3 d-flex align-items-end gap-2 screenFeaturesRoot">
              <div className={classes.filterbox}>
                <h1 className="mb-2">Body Type</h1>
                <select
                  name="bodyType"
                  value={filters.bodyType}
                  onChange={handleFilterChange}
                  className="p-2 border rounded-md"
                >
                  <option value="">Select Body Type</option>
                  {filterOptions.bodyTypeOptions.map((option) => (
                    <option key={option.iBodyTypeId} value={option.iBodyTypeId}>
                      {option.sName}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className={classes.filterbox}>
                <h1 className="mb-2">Company</h1>
                <select
                  name="company"
                  value={filters.company}
                  onChange={handleFilterChange}
                  className="p-2 border rounded-md"
                >
                  <option value="">Select Company</option>
                  {filterOptions.companyOptions.map((option) => (
                    <option key={option.iStoreId} value={option.iStoreId}>
                      {option.sName}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className={classes.filterbox}>
                <h1 className="mb-2">Gender</h1>
                <select
                  name="gender"
                  value={filters.gender}
                  onChange={handleFilterChange}
                  className="p-2 border rounded-md"
                >
                  <option value="">Select Gender</option>
                  {filterOptions.genderOptions.map((option) => (
                    <option key={option.iGenderId} value={option.iGenderId}>
                      {option.sName}
                    </option>
                  ))}
                </select>
              </div>
              <div className={classes.filterbox}>
                <h1 className="mb-2">Status</h1>
                <select
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                  className="p-2 border rounded-md"
                  style={{
                    backgroundColor: filterOptions?.statusOptions?.find(
                      (option) =>
                        String(option?.iStatusId) === String(filters?.status)
                    )?.sColor,
                  }}
                >
                  <option value="">Select Status</option>
                  {filterOptions?.statusOptions?.map((option) => (
                    <option
                      key={option.iStatusId}
                      value={option.iStatusId}
                      style={{ backgroundColor: option.sColor }}
                    >
                      {option.sName}
                    </option>
                  ))}
                </select>
              </div>
              <div
                onClick={handleDeleteClick}
                className={`flex items-center justify-center ${classes.clearButton}`}
              >
                <span>Clear All Data</span>
                <RiDeleteBin6Line size={20} />
              </div>
            </div>

            {isDeleteConfirmationOpen && (
              <div className={classes.modal_overlay}>
                <div className={classes.modal_content}>
                  <p>Are you sure you want to delete?</p>
                  <button onClick={handleDeleteConfirm}>Yes</button>
                  <button onClick={() => setIsDeleteConfirmationOpen(false)}>
                    No
                  </button>
                </div>
              </div>
            )}

            {isFinalConfirmationOpen && (
              <div className={classes.modal_overlay}>
                <div className={classes.modal_content}>
                  <p>
                    You are about to delete {products.length} items. Do you want
                    to proceed?
                  </p>
                  <button onClick={handleFinalDeleteConfirm}>Confirm</button>
                  <button onClick={() => setIsFinalConfirmationOpen(false)}>
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {!loader ? (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 my-4">
                  {products.length > 0 ? (
                    <>
                      {products.map((product, idx) => {
                        return (
                          <div
                            className="relative bg-white rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                            key={idx}
                          >
                            <div
                              className={`${classes.productsimg} mx-auto relative`}
                            >
                              <Link to={`/product/${product?.iProductId}`}>
                                <img
                                  src={product.sImageURL || placeholder}
                                  alt="Thumbnail"
                                  className="object-contain"
                                />
                              </Link>
                              {!product.sImageURL && (
                                <div
                                  onClick={() => {
                                    handleImageUploadModalToggle(),
                                      setSelectedProduct(product);
                                  }}
                                  className="absolute inset-0 flex items-center justify-center cursor-pointer"
                                >
                                  <FiPlusCircle
                                    size={50}
                                    className="text-blue-500"
                                  />
                                </div>
                              )}
                            </div>

                            <FaInfoCircle
                              className="absolute top-2 right-2 text-blue-500"
                              size={20}
                              onMouseEnter={() => handleMouseEnter(product)}
                              onMouseLeave={handleMouseLeave}
                            />
                            {showTooltip &&
                              tooltipData.iProductId === product.iProductId && (
                                <div
                                  className={classes.tooltip}
                                  style={{
                                    position: "absolute",
                                    top: "30px",
                                    left: "10px",
                                    right: "10px",
                                  }}
                                >
                                  <div
                                    className={`bg-white p-2 rounded ${classes.smallBoxdetails}`}
                                  >
                                    <p>
                                      <strong>Name:</strong> {tooltipData.sName}
                                    </p>
                                    <p>
                                      <strong>Image Count:</strong>{" "}
                                      {tooltipData.iImageCount}
                                    </p>
                                    <p>
                                      <strong>Body Type:</strong>{" "}
                                      {tooltipData.sBodyTypeName}
                                    </p>
                                    <p>
                                      <strong>Gender:</strong>{" "}
                                      {tooltipData.sGenderName}
                                    </p>
                                    <p>
                                      <strong>Company:</strong>{" "}
                                      {tooltipData.sStore}
                                    </p>{" "}
                                    <p>
                                      <strong>sku:</strong> {tooltipData.sSKU}
                                    </p>
                                  </div>
                                </div>
                              )}

                            <div className={classes.photolistcount}>
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.99999 2.66666H10.6667C10.8435 2.66666 11.013 2.73689 11.1381 2.86192C11.2631 2.98694 11.3333 3.15651 11.3333 3.33332V5.66666M13.3333 3.99999C13.5093 4.07466 13.68 4.14466 13.8453 4.20999C14.0081 4.27905 14.1367 4.40992 14.203 4.57382C14.2692 4.73772 14.2677 4.92123 14.1987 5.08399L12.6667 8.66666M2.40265 4.79799L7.16132 2.72532C7.23984 2.69167 7.32431 2.67407 7.40974 2.67358C7.49517 2.67308 7.57984 2.6897 7.65875 2.72244C7.73765 2.75518 7.80921 2.80339 7.86919 2.86423C7.92917 2.92506 7.97636 2.99729 8.00799 3.07666L11.2907 11.0113C11.3589 11.1722 11.3612 11.3535 11.2971 11.5161C11.233 11.6787 11.1077 11.8096 10.948 11.8807L6.18999 13.9533C6.11143 13.9871 6.0269 14.0048 5.9414 14.0053C5.85589 14.0059 5.77114 13.9893 5.69216 13.9565C5.61317 13.9238 5.54155 13.8755 5.48152 13.8146C5.42149 13.7537 5.37427 13.6814 5.34265 13.602L2.05999 5.66666C1.99175 5.50576 1.98943 5.3245 2.05352 5.16191C2.11761 4.99931 2.24299 4.86906 2.40265 4.79799Z"
                                  stroke="#98A4AE"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <span>{product.iImageCount}</span>
                            </div>

                            <div className={classes.productName}>
                              <div className="flex items-center gap-2">
                                <Link to={`/product/${product?.iProductId}`}>
                                  <span className="font-semibold text-gray-800">
                                    {product.sName}
                                  </span>
                                </Link>
                                {product.sSKU && (
                                  <button
                                    onClick={() => {
                                      navigator.clipboard.writeText(
                                        product.sSKU
                                      );
                                      toast.success("SKU Copied to clipboard");
                                    }}
                                    className="text-xs text-blue-500 hover:underline"
                                    title="Copy SKU"
                                  >
                                    <FiCopy size={16} />
                                  </button>
                                )}
                              </div>
                              <span className={classes.photoliststatusBox}>
                                {product.sColor ? (
                                  <div
                                    style={{
                                      backgroundColor: product.sColor,
                                      border: `1px solid ${product.sColor}`,
                                    }}
                                    className={classes.photoliststatus}
                                  ></div>
                                ) : null}
                                {product.sImageStatusName}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <div className="text-center col-span-12">
                      No Products Found!
                    </div>
                  )}
                </div>

                {totalCount > 12 ? (
                  <div className="screenTablePaginationRoot">
                    <Pagination
                      activePage={currentPage}
                      itemsCountPerPage={12}
                      totalItemsCount={totalCount}
                      pageRangeDisplayed={5}
                      onChange={handlePageClick}
                      nextPageText={">"}
                      prevPageText={"<"}
                      firstPageText={"<<"}
                      lastPageText={">>"}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                ) : null}
              </>
            ) : (
              <div className="screenTableRootLoader">
                <SmallLoader />
              </div>
            )}
          </div>
          <ImageUploadModal
            isOpen={isImageUploadModalOpen}
            onClose={handleImageUploadModalToggle}
            onUploadSuccess={handleImageUploadSuccess}
            selectedProduct={selectedProduct}
            isBulk={false}
            type={"product"}
          />

          <ProductBulkUpload
            isOpen={isModalOpen}
            onClose={handleModalToggle}
            fetchProducts={fetchProducts}
          />

          <ImageUploadModal
            isOpen={isBulkModalOpen}
            onClose={handleBulkModalToggle}
            onUploadSuccess={handleImageUploadSuccess}
            isBulk={true}
            type={""}
          />
          {/*  */}
          {openSandboxPush && (
            <Suspense fallback={null}>
              <PushToCmsModal
                openSandboxPush={openSandboxPush}
                setOpenSandboxPush={setOpenSandboxPush}
                summaryLoader={summaryLoader}
                openSandboxMessage={openSandboxMessage}
                pushSummary={pushSummary}
                pushLoader={pushLoader}
                handlePush={handlePush}
                fetchProducts={fetchProducts}
                setOpenSandboxMessage={setOpenSandboxMessage}
                sandBoxStatus={sandBoxStatus}
                rejectedProducts={rejectedProducts}
                openRows={openRows}
                toggleRow={toggleRow}
              />
            </Suspense>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductListing;
